import React, { useState } from 'react';

const PercentageChangeCalculator = () => {
  
  const [value1, setValue1] = useState('');
  const [option, setOption] = useState('increase');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Veuillez entrer les deux valeurs correctement');
      setResult('');
      setExplanation('');
      return;
    }
    const val1 = parseFloat(value1);
    const percent = parseFloat(value2);
    let calculatedValue = 0;
    let calculationSteps = `${val1} ${option === 'increase' ? 'augmenté' : 'diminué'} par ${value2}% = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${value2}%) = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${percent}) = `;
    if (option === 'increase') {
      calculatedValue = val1 + (val1 * percent) / 100;
    } else {
      calculatedValue = val1 - (val1 * percent) / 100;
    }
    setResult(calculatedValue.toFixed(2));
    setExplanation(calculationSteps + calculatedValue.toFixed(2));
    setError('');
  };

  return (
    <div>
      <u><h2 style={{ fontSize: '16px' }}>Calculatrice de changement de pourcentage</h2></u><br />
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <label htmlFor="pcc-value1">Valeur:</label>
        <input
          type="number"
          placeholder="Valeur"
          value={value1}
          id="pcc-value1"
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ width: '120px', marginLeft: '5px' }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
        <label htmlFor="pcc-option">Changement:</label>
        <select
          id="pcc-option"
          className="form-select"
          value={option}
          onChange={(e) => setOption(e.target.value)}
          style={{ flex: 1, minWidth: '130px' }}
        >
          <option value="increase">Augmentation</option>
          <option value="decrease">Diminution</option>
        </select>
        <input
          type="number"
          placeholder="Pourcentage"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <span>%</span>
        <button className="btn btn-success" onClick={handleCalculate}>Calculer</button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-dark">Erreur: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  Résultat: {value1} {option === 'increase' ? 'augmentation' : 'diminution'} {value2}% = {result}
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-dark">
                    Étapes: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PercentageChangeCalculator;
